import React, { useState } from 'react';
import { useParams,useLocation } from 'react-router-dom';
import { ReactComponent as AddTeamVector } from '../../../../CompanyManagment/StaticData/Vectors/addTeamVector.svg';
import { Grid, Box, Typography ,Button} from '@mui/material';
import { Formik, Form } from 'formik';
import { addTeamValues } from '../../../../OKRManagment/StaticData';
import DyButton from '../../../../../components/GlobalComponents/DyButton/DyButton';
import FormikControl from '../../../../../components/FormikControls/FormikControl';
import { addTeamsinintialValues } from '../../../../CompanyManagment/StaticData';
import { useAddTeam } from '../../../../CompanyManagment/Hooks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { addTeamSchema } from '../../../../CompanyManagment/StaticData';
import { useGetAllActivePersonByTenantId } from '../../../../CompanyManagment/Hooks';
import MultiSelect from '../../../../../components/FormikControls/MultiSelect/MultiSelect';
import {ErrorMessage } from 'formik';
// import { useSelector } from 'react-redux';
// import "../RegisterTenant/Error.css";
// import React, { useState,useEffect } from 'react';
// import { useParams,useLocation } from 'react-router-dom';
// import { addKeyResultSchema } from '../../StaticData/index';
// import FormikControl from '../../../../components/FormikControls/FormikControl';
// import { Box, Grid, TextField, Typography,MenuItem,InputLabel,FormControl,Select } from '@mui/material';
// import MultiSelect from '../../../../components/FormikControls/MultiSelect/MultiSelect';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
// import { Formik, Form } from 'formik';
// import MultiSel from '../../../../components/MultiSel/MultiSel';
import DYToastMessage from '../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
// import DySplitButton from '../../../../components/GlobalComponents/DySplitButton/DySplitButton';
// import "../../../CompanyManagment/Forms/RegisterTenant/Error.css"
interface createTeamFace{
  parentId:any,
    addKrSuccess:() => any,
    setShowToastMessage:(show:boolean) => void
    setAddKrState:(show:any) => void,
    setShowCreateTeam:(show:boolean)=>void

  }

export const CreateChild = ({parentId,addKrSuccess,setShowToastMessage,setAddKrState,setShowCreateTeam}:createTeamFace) => {
  const location:any=useLocation();
  let{state:{objectiveId}}:any=location;
  const[idsValue,setIdsValue]=useState<any[]>([]);
  const tenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
  // const{data:teamsOptions,isLoading:teamOPloading}=useGetAllObjectiveDefinitionLevelByTenantId(tenantId);
  // const{data:HorzinalAlignData}=useGetAllObjectiveDefinitionLevelByTenantId1(tenantId,definitionId);
  // const {data:acPersOptions}=useGetAllActivePersonByTenantId(tenantId);
  // const{data:submitFormOptions}=useGetAllOKRStateByTenantId(tenantId);
  // const{data:levelIds,isFetched:getLevelsIds}:any=useGetAllScoreLevelsByTenantId(tenantId);

  // const{mutate:addKeyResulttt,isSuccess,data,isLoading:AddKrLoading}=useAddKeyResult();
  // const initialAddKeyR = (data: any) => {
      
  //     let{pointingSystemType}=data;

  //     let ids=pointingSystemType==='Regularly'?[{...hundredValue}]:idsValue;
  //     let totalData={tenantId:tenantId,objectiveId:objectiveId,onValue:'',...data};
  //     totalData.valuesDetailCommandDtos=ids;
  //     totalData.horizontalAlignments=horizontalAlignments.map((({value})=>value))      
  //     // console.log(totalData);


  //     addKeyResulttt(totalData)
   
  // }
 const{data:activePersonData,isLoading:getActivePersonLoading}=useGetAllActivePersonByTenantId(tenantId);
 const[personIdData,setPersonIdData]=useState([])
  const { data: addTeamData, mutate: addTeam,isSuccess} = useAddTeam();


  useEffect(() => {
    setPersonIdData(activePersonData?.map((item:any)=>{
      let{key,value}=item;
      return {year:value,title:key}
    }))
  }, [activePersonData]);


  // useEffect(() => {
  //  if (addTeamData) {
  //   setShowToastMessage(true)
  //   setAddTeamState(addTeamData?.data)
  //   onClose(false)
  //  }
    
  // }, [addTeamData,isSuccess])
  


  const initialSubmitForm = (data: any) => {
    addTeam({...data,tenantId:tenantId,parentId:parentId})
    // console.log(data)
  }

  return (
    <Grid container>
      <Grid item xs={12}  >
        <Box width={'100%'} textAlign={'center'}   >
          <AddTeamVector style={{ height: '150px' }} />
        </Box>
      </Grid>
      <Grid item xs={12}   >

      
    
     <Formik 
      enableReinitialize
      initialValues={addTeamsinintialValues}
      validationSchema={addTeamSchema}
      onSubmit={(data: any) => {
        initialSubmitForm(data)

      }}
    >
      {
        ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
          <Form>
            <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}   >

              <Grid item xs={12}   >

              </Grid>
              <Grid item xs={12} md={12}  >
              <div className='error'>
              <ErrorMessage name="name" />
              </div>
                <FormikControl
                  control='textField'
                  type='text'
                  label='نام'
                  name='name'
                  fullWidth
                  value={values.name || ''}
                />
              </Grid>



              <Grid item xs={12} md={12}  >
              <div className='error'>
              <ErrorMessage name="managerId" />
              </div>
                <FormikControl
                  control='select'
                  options={activePersonData||[]}
                  label='مدیر'
                  name='managerId'
                  fullWidth
                  values={values?.managerId || ''}
                />
              </Grid>

              <Grid item xs={12} md={12} >
              <div className='error'>
              <ErrorMessage name="personIds" />
              </div>
              <MultiSelect
                options={personIdData || []}
                isLoading={getActivePersonLoading}
                onChangee={setFieldValue}
                propName='personIds'
                label={'انتخاب اعضا'}
              />
              </Grid>        

              <Grid item xs={12} mt={1}  >
                <Box px={1} columnGap={2} display={'flex'} justifyContent={'center'} flexDirection={'row-reverse'}  >
                  <Box >
                    <DyButton
                      caption={'ذخیره'}
                      color={'#00387C'}
                      onClick={() => { }}
                      disbled={!dirty || !isValid}
                      variant={'contained'}
                      bgColor={'#00387C'}
                      type={'submit'}
                    />
                  </Box>

                  <Box>
                    <DyButton
                      caption={'انصراف'}
                      disbled={false}
                      variant={'outlined'}
                      onClick={()=>{
                        //onClose(false)
                      }}
                    />
                  </Box>

                </Box>
              </Grid>


            </Grid>


          </Form>
      }

    </Formik>
      </Grid>
    </Grid>
  )

}
export default CreateChild